import { render } from "./BGZG9.vue?vue&type=template&id=4793b772&scoped=true"
import script from "./BGZG9.vue?vue&type=script&lang=js"
export * from "./BGZG9.vue?vue&type=script&lang=js"

import "./BGZG9.vue?vue&type=style&index=0&id=4793b772&lang=css"
import "./BGZG9.vue?vue&type=style&index=1&id=4793b772&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4793b772"]])

export default __exports__